import { render, staticRenderFns } from "./surgeries.vue?vue&type=template&id=b2c32e3a&scoped=true"
import script from "./surgeries.vue?vue&type=script&lang=js"
export * from "./surgeries.vue?vue&type=script&lang=js"
import style0 from "./surgeries.vue?vue&type=style&index=0&id=b2c32e3a&prod&scoped=true&lang=css"
import style1 from "./surgeries.vue?vue&type=style&index=1&id=b2c32e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c32e3a",
  null
  
)

export default component.exports